// @react
import React, { ReactElement } from 'react'
// @types
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @graphQL
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @components
import CreateAccountForm from 'modules/onBoarding/components/CreateAccount/Form'
import QueryError from 'modules/common/components/Errors/QueryError'

const CreateAccountContainer = (): ReactElement => {
  /******************************************
   * GQL HOOKS
   ******************************************/

  const {
    loading: isLoading,
    error: isError,
    data: userData,
    refetch,
  } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
  })

  /******************************************
   * RENDER
   ******************************************/

  if (isError) return <QueryError />

  return (
    <CreateAccountForm
      data={userData}
      isLoading={isLoading}
      refetch={refetch}
    />
  )
}

export default CreateAccountContainer
